/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { createBrowserRouter } from "react-router-dom";
import { redirectLoader } from "./redirect-loader";
import { RouterError } from "cms/layout/error/router-error";
import { ApplicationLayout } from "layout/application-layout";
import { ApplicationNewsLayout } from "layout/news-layout";
import { Search } from "pages/search";
import { News } from "pages/news";
import { Home } from "pages/home";
import { Events } from "pages/events";
import { Advisories } from "pages/notices";
import { Alerts } from "pages/alerts";
import { Webpage } from "pages/webpage";
import { Licences } from "pages/licences";
import { EventSearch } from "pages/events-search";
import { ServicesLayout } from "layout/services/ServicesLayout";
import { PublicPermits } from "pages/public-permits";
import { YourPermits } from "pages/your-permits";
import { ApplyForAPermit } from "pages/apply-for-a-permit";

/**
 * Data enabled routes for the application.  This exists outside of the app itself
 * as they only need to be rendered once.
 */
export const router = createBrowserRouter([
    // {
    //     path: "/",
    //     element: (
    //         <Navigate to="/services" />
    //     ),
    //     errorElement: <RouterError />,
    //     loader: redirectLoader,
    // },
    {
        path: "/",
        element: <Home />,
        errorElement: <RouterError />,
    },
    {
        path: "/static_permits",
        element: (
            <ServicesLayout
                crumbs={[{ path: "/", title: "Services" }, { path: "/static_permits", title: "Permits" }]}
                selectedSection={"Permits"}
            />
        ),
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <PublicPermits />,
            },
        ],
    },
    {
        path: "static_permits/your-permits",
        element: (
            <ServicesLayout
                crumbs={[{ path: "/", title: "Services" }, { path: "/static_permits", title: "Permits" }, { title: "Your Permits" }]}
                selectedSection={"Your permits"}
            />
        ),
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <YourPermits />,
            },
        ],
    },
    {
        path: "static_permits/apply-for-a-permit",
        element: (
            <ServicesLayout
                crumbs={[{ path: "/", title: "Services" }, { path: "/static_permits", title: "Permits" }, { title: "Apply for a permit" }]}
                selectedSection={"Apply for a permit"}
            />
        ),
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <ApplyForAPermit />,
            },
        ],
    },

    // example of nested application layout structure
    {
        path: "/search",
        element: <ApplicationLayout crumbs={[{ path: "/", title: "Home" }, { title: "Search Results" }]} />,
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <Search />,
            },
        ],
    },
    {
        path: "/events",
        element: (
            <ApplicationNewsLayout
                crumbs={[{ path: "/", title: "Home" }, { title: "Events" }]}
                customClass={"events-page"}
                selectedSection={"Events"}
            />
        ),
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <Events />,
            },
        ],
    },
    {
        path: "/news",
        element: (
            <ApplicationNewsLayout
                crumbs={[{ path: "/", title: "Home" }, { title: "News" }]}
                selectedSection={"News"}
            />
        ),
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <News />,
            },
        ],
    },
    {
        path: "/advisories",
        element: (
            <ApplicationNewsLayout
                crumbs={[{ path: "/", title: "Home" }, { title: "Advisories" }]}
                selectedSection={"Advisories"}
            />
        ),
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <Advisories />,
            },
        ],
    },
    {
        path: "/alerts",
        element: (
            <ApplicationNewsLayout
                crumbs={[{ path: "/", title: "Home" }, { title: "Alerts" }]}
                selectedSection={"Alerts"}
            />
        ),
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <Alerts />,
            },
        ],
    },
    {
        path: "/licences",
        element: (
            <ApplicationNewsLayout
                crumbs={[{ path: "/", title: "Home" }, { title: "Licences" }]}
                selectedSection={"Licences"}
            />
        ),
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <Licences />,
            },
        ],
    },
    {
        path: "/events/search",
        element: (
            <ApplicationNewsLayout
                crumbs={[{ path: "/", title: "Home" }, { title: "Events" }]}
                selectedSection={"Events"}
            />
        ),
        errorElement: <RouterError />,
        loader: redirectLoader,
        children: [
            {
                index: true,
                element: <EventSearch />,
            },
        ],
    },

    // catch all for paths of any length
    // will need to handle its own 404 logic
    {
        path: "*",
        element: <Webpage />,
        errorElement: <RouterError />,
        loader: redirectLoader,
    },
    {
        future: {
            // https://reactrouter.com/6.30.0/upgrading/future
            // https://github.com/remix-run/react-router/blob/main/CHANGELOG.md
            // v7_startTransition: true,
            // v7_fetcherPersist: true,
            // v7_normalizeFormMethod: true,
            // v7_partialHydration: true,
            // v7_relativeSplatPath: true,
            // v7_skipActionErrorRevalidation: true,
        }
    }
]);
